import React, { useState } from 'react';
import {
  Calendar,
} from 'react-big-calendar';
import {
  DateTime,
} from 'luxon';

import {
  ActivityModal,
  WorkoutResult,
} from 'web-components';

import Toolbar from './Toolbar';
import LuxonLocalizer from './luxonLocalizer';

import * as S from './styled';

interface ComponentProps {
  clients: any[]
  calendarSelectedUser: any
  onFilter: { (userId: number): void }
  onNewWorkoutClick: { ({ start }: { start: Date }): void }
}

type EventProps = {
  event: {
    color: string,
    startTime: string,
    person_name: string,
  }
};

const getComponents = ({
  clients,
  calendarSelectedUser,
  onFilter,
  onNewWorkoutClick,
}: ComponentProps) => ({
  toolbar: props => (
    <Toolbar
      {...props}
      onNewWorkoutClick={() => onNewWorkoutClick({ start: Date.now() })}
      clients={clients}
      onFilter={onFilter}
      calendarSelectedUser={calendarSelectedUser}
    />
  ),
  event: ({ event }: EventProps) => (
    <S.Event color={event.color}>
      {event.startTime}
      {' '}
      {event.person_name}
    </S.Event>
  ),
});

type Props = ComponentProps & {
  events: Array<any>,
  onNavigate: { (day: Date): void },
};

const CalendarContainer = (props: Props) => {
  const [selectedLog, setSelectedLog] = useState<any>(null);
  const [selectedEvent, setSelectedEvent] = useState<any>(null);
  const {
    events,
    onNavigate,
    onNewWorkoutClick,
  } = props;

  return (
    <S.CalendarContainer>
      <Calendar
        style={{
          width: '100%',
        }}
        views={['month']}
        popup
        events={events}
        selectable
        endAccessor="end"
        startAccessor="start"
        localizer={LuxonLocalizer(DateTime, { firstDayOfWeek: 0 })}
        components={getComponents(props)}
        onSelectEvent={(event) => {
          if (event.isLog) setSelectedLog(event);
          if (!event.isLog) setSelectedEvent(event);
        }}
        onNavigate={onNavigate}
        onSelectSlot={onNewWorkoutClick}
      />
      <ActivityModal
        id={selectedLog?.id}
        onRequestClose={() => setSelectedLog(null)}
      />
      <WorkoutResult
        id={selectedEvent?.id}
        onRequestClose={() => setSelectedEvent(null)}
      />
    </S.CalendarContainer>
  );
};

export default CalendarContainer;
